import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface PaymentListTemplateProps {
  readonly filterPanel: ReactNode;
  readonly table: ReactNode;
}

export function PaymentListTemplate({ filterPanel, table }: PaymentListTemplateProps) {
  const { t } = useTranslation('personManagement');

  return (
    <div className="flex flex-col gap-nano">
      <Breadcrumb>
        <BreadcrumbLink>
          <Link to="/">
            <BreadcrumbIcon />
          </Link>
        </BreadcrumbLink>

        <BreadcrumbLink>
          <Link to="/persons">{t('breadcrumb.persons')}</Link>
        </BreadcrumbLink>
        <BreadcrumbPage>{t('breadcrumb.payments')}</BreadcrumbPage>
      </Breadcrumb>

      <div className="flex flex-col gap-nano">
        <h1 className="ts-heading-lg text-ctx-content-title">{t('paymentList.title')}</h1>
        <p className="ts-paragraph-xs text-ctx-content-title">{t('paymentList.subtitle')}</p>
      </div>

      <div className="rounded-md my-xxs border-hairline border-ctx-layout-border bg-ctx-layout-surface p-xs shadow-level1">
        {filterPanel}
      </div>

      {table}
    </div>
  );
}
